export default "__VITE_ASSET__FIGTJAZr__"